module.exports = __webpack_public_path__ + "img/logo.f9058747.png";